import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import DropDown from '../../../../../../../components/DropDown';
import {useGetAllDropdownAssignmentsMutation} from '../../../../../../../features/authentication/assignmentApislice';
import PropTypes from 'prop-types';
import ActivityTypes from '../../../../../../../enums/activityTypes';
import { useGetAllDropdownFlashcardsMutation } from '../../../../../../../features/authentication/activityApiSlice';

const AddQuestionsToExisting = ({handleSave, handleCancel, activityType})=>
{
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);
  const [getAllDropdownAssignments] = useGetAllDropdownAssignmentsMutation();
  const [getAllDropdownFlashcards] = useGetAllDropdownFlashcardsMutation();

  useEffect(() => {  
    const fetchAssignmentData = async () => {
      const obj = {
        id: 0,
        name: `Select ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`
      };
      let response = [];
      if(activityType == ActivityTypes.Assignment)
        response = await getAllDropdownAssignments().unwrap();
      else
        response = await getAllDropdownFlashcards().unwrap();

      const responseArray = [obj, ...response];
      setAssignments(responseArray);
    };
    fetchAssignmentData();

  }, [getAllDropdownAssignments]);

  const handleSelectAssignment = (event) => {
    setSelectedAssignmentId(parseInt(event.target.value));
  };

  const saveOnClick = ()=>
  {
    if(selectedAssignmentId && selectedAssignmentId>0)
    {
      handleSave(selectedAssignmentId);
    }else{
      setSelectedAssignmentId(0);
    }
  };

  return (
    <>
      <Row className='mb-5'>
        <Col className="">
          <DropDown
            label={`Select ${activityType == ActivityTypes.Assignment ? 'an Assignment' : 'a Flashcard'}`}
            value={assignments}
            onChangeHandler={(e) => handleSelectAssignment(e)}
            selectedValue={selectedAssignmentId}
            showValidation={selectedAssignmentId == 0}
            validationMessage={`Please Select ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}`}
            disabledMessage={`${activityType == ActivityTypes.Assignment ? 'Questions' : 'Vocabularies'} cannot be added to an ${activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'} that already has students assigned to it`}
          />
        </Col>
      </Row>
      <Row>
        <div className="d-flex justify-content-end gap-3 align-items-center">
          <button className="btn btn-castleGray option-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-castleRed option-btn" onClick={saveOnClick}>
            Save
          </button>        
        </div>  
      </Row>
    </>
  );
};

AddQuestionsToExisting.propTypes = {
  handleSave: PropTypes.func,
  handleCancel: PropTypes.func,
  activityType: PropTypes.number
};

export default AddQuestionsToExisting;